import React, { useMemo, useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import DialogTitle from "../../../components/dialog-title";
import { currencyFormat } from "../../../helpers";
import { useErrorHandler } from "../../../hooks";
import ordersService from "../../../services/orders.service";

export default function InPersonPaymentForm({ close, data }) {
  const remainingAmount = useMemo(
    () => Number(data?.remainingAmount || 0),
    [data]
  );
  const [amount, setAmount] = useState(remainingAmount);
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const errorHandler = useErrorHandler();

  const handleSubmit = async () => {
    const paymentAmount = Number(amount || 0);
    if (paymentAmount <= 0) {
      enqueueSnackbar("مبلغ پرداخت باید بزرگ‌تر از صفر باشد.", {
        variant: "warning",
      });
      return;
    }
    if (paymentAmount > remainingAmount) {
      enqueueSnackbar("مبلغ پرداخت نمی‌تواند بیشتر از مانده سفارش باشد.", {
        variant: "warning",
      });
      return;
    }

    setSubmitting(true);
    const { error } = await ordersService.createInPersonPayment(data.id, {
      amount: paymentAmount,
      method: "inPerson",
      description: description || undefined,
    });
    setSubmitting(false);

    if (error) return errorHandler(error);
    enqueueSnackbar("پرداخت مانده با موفقیت ثبت شد.", { variant: "success" });
    close(true);
  };

  return (
    <>
      <DialogTitle onClose={() => close()}>ثبت پرداخت مانده</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2} className="mt-2">
          <Grid item xs={12} sm={4}>
            <Typography color="textSecondary">مبلغ کل</Typography>
            <Typography>{currencyFormat(data?.totalAmount || 0)}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography color="textSecondary">پرداخت‌شده</Typography>
            <Typography>{currencyFormat(data?.depositAmount || 0)}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography color="textSecondary">مانده</Typography>
            <Typography>{currencyFormat(remainingAmount)}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              type="number"
              variant="outlined"
              label="مبلغ پرداخت"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              inputProps={{ min: 1, max: remainingAmount }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              variant="outlined"
              label="توضیحات"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} color="primary" disabled={submitting}>
          لغو
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={submitting || remainingAmount <= 0}
        >
          ثبت پرداخت
        </Button>
      </DialogActions>
    </>
  );
}
